import axios from 'axios'
// import requestHeader from './request.header'
import url from './request.url'

export default class AccountApi {
    
  constructor() {
  }

  signin(creds, callback) {
    return axios.post(
      url.application.account.signin, creds
    ).then(res => {
      callback(res.data ? res.data : {})
      // console.log(`res.data: %s`, JSON.stringify(res.data))
    }).catch(error => {
      if(error && error.response) {
        // console.log(`res.data: %s`, JSON.stringify(error))
        callback(error.response.data ? error.response.data : {})
      } else {
        // console.log(`else: {}`)
        callback({})
      }
    })
  }
}
